module.exports = __webpack_public_path__ + "static/media/retirement-object-4-1-1.d5332ad3.svg";